// removed by extract-text-webpack-plugin
module.exports = {"terms-hero":"terms-hero","terms-hero-background":"terms-hero-background","terms-hero-content":"terms-hero-content","last-updated":"last-updated","terms-icon":"terms-icon","terms-main-content":"terms-main-content","terms-content":"terms-content"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/static/TermsOfUse/TermsOfUse.scss
// module id = 4391
// module chunks = 1